// app.injector.ts
import { EnvironmentInjector } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AppInjector {
  private static injector: EnvironmentInjector;

  static set(injector: EnvironmentInjector) {
    AppInjector.injector = injector;
  }

  static get(): EnvironmentInjector {
    if (!AppInjector.injector) {
      throw new Error('Injector has not been set yet.');
    }
    return AppInjector.injector;
  }
}
